import React from 'react';
import { useHistory } from 'react-router-dom';
import { Book, Clipboard } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useRFQProductTemplatesStore } from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import { observer } from 'mobx-react-lite';
import { ButtonStyled, NavSectionStyled } from './styles';

export const NavSection: React.FC = observer(() => {
  const history = useHistory();
  const { showInitialSeedFeature } = useRFQProductTemplatesStore();
  const redirectToShelfTemplates = (): void => {
    history.push('/shelf-product-templates');
  };

  const redirectToInitialSeed = (): void => {
    history.push('/initial-seed-templates');
  };

  return (
    <NavSectionStyled>
      <ButtonStyled
        type="text"
        onClick={redirectToShelfTemplates}
        color="primary"
        size="medium"
        leftIconProp={<Book />}
      >
        View product template associations
      </ButtonStyled>
      {showInitialSeedFeature && (
        <ButtonStyled
          type="text"
          onClick={redirectToInitialSeed}
          color="primary"
          size="medium"
          leftIconProp={<Clipboard />}
        >
          View initial seed product templates
        </ButtonStyled>
      )}
    </NavSectionStyled>
  );
});
